import { createEmailChannelWithSendGrid } from "../emailChannel";
export default async function createDefaultCommunicationChannel(
  userId: string,
  whiteLabelId: string
) {
  try {
    const defaultApiKey = process.env.DEFAULT_SAJILNI_SENDGRID_API_KEY;
    const defaultSenderEmail =
      process.env.DEFAULT_SAJILNI_SENDGRID_SENDER_EMAIL;
    const defaultFromName = process.env.DEFAULT_SAJILNI_SENDGRID_FROM_NAME;
    if (!defaultApiKey || !defaultSenderEmail) {
      console.warn(
        "⚠️  Default SendGrid credentials not configured. " +
          "White-label created without email channel. " +
          "Set DEFAULT_SAJILNI_SENDGRID_API_KEY and DEFAULT_SAJILNI_SENDGRID_SENDER_EMAIL."
      );
      return {
        success: false,
        message: "Default SendGrid credentials not configured",
      };
    }

    console.log(
      `✅ Creating default communication channel for white-label ${whiteLabelId}`
    );

    // Create email channel with SendGrid using the helper function
    // This also creates the communication channel if not provided
    const result = await createEmailChannelWithSendGrid(
      userId,
      whiteLabelId,
      defaultApiKey,
      defaultSenderEmail,
      undefined,
      defaultFromName
    );

    if (result.error) {
      console.error(
        "❌ Failed to create default communication channel:",
        result.error
      );
      throw result.error;
    }

    console.log(
      `✅ Default SendGrid channel created successfully for white-label ${whiteLabelId}`
    );
    return {
      success: true,
      emailChannel: result.emailChannel,
    };
  } catch (error) {
    console.error("❌ Error creating default communication channel:", error);
    // Don't throw - allow white-label creation to succeed even if this fails
    return {
      success: false,
      error: error instanceof Error ? error.message : String(error),
    };
  }
}
